// toastService.js
import { bottomNavigationActionClasses } from '@mui/material';
import { toast } from 'react-toastify';

const toastService = (t) => ({
  success: (messageKey, options = {}) => {
    toast.success(t(messageKey), { ...options,position:'top-right' });
  },
  error: (messageKey, options = {}) => {
    toast.error(t(messageKey), { ...options, position:'top-right'});
  },
  info: (messageKey, options = {}) => {
    toast.info(t(messageKey), { ...options, position:'top-center' });
  },
  default: (messageKey, options = {}) => {
    toast(t(messageKey), { ...options, position:'bottom-center' });
  },
});

export default toastService;
